export const funciones = {
    listaErrores: (json) => {
        let res = "<strong>Errores: </strong> <br><br>";
        let dataError = json;
        $.each(dataError, function (i, item) {
            res += "-" + item + "<br>";
        })
        return res;
    },

    msg(swal, msg){
        swal(msg);
    },      
    ok(swal, msg) {
        swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            text: msg,
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true
        });
    },
    error(swal, msg) {
        swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: msg,
        });
    },
    validate(swal, msg) {
        swal.fire({
            icon: 'error',
            title: 'Error de validación...',
            html: msg,
        });
    },
    confirm(swal, msg, title = "¿Estás seguro?"){
        return swal.fire({
            title: title,
            text: msg,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar'
        });
    }
};
